import * as Yup from "yup";

export const cloneSchema = Yup.object().shape({
  cloneName: Yup.string().required("Product name is required"),
  cloneCode: Yup.string().required("Product code is required"),
});
